import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  SelectChangeEvent,
  CircularProgress,
  InputAdornment,
  Box,
  OutlinedInput,
  Typography,
} from '@mui/material';
import ErrorMessage from '../ErrorMessage/ErrorMessage';

export interface Item {
  value: string | number | undefined;
  name: string | undefined;
}

interface DefaultSelectProps {
  value: string | null;
  onChange: (item: Item) => void;
  selectName: string;
  labelId: string;
  onBlur?: () => void;
  items?: Item[];
  disabled?: boolean;
  isLoading?: boolean;
  error?: boolean;
  errorMessage?: string | null;
  placeholder?: string;
}

export function DefaultSelect({
  value,
  onChange,
  onBlur,
  items = [],
  selectName,
  labelId,
  disabled = false,
  isLoading = false,
  error,
  errorMessage,
  placeholder,
}: DefaultSelectProps): JSX.Element {
  const handleChange = (event: SelectChangeEvent<string>) => {
    const selectedValue = event.target.value;
    const selectedItem = items?.find((item) => item.value === selectedValue);

    if (selectedItem) {
      onChange(selectedItem);
    }
  };

  return (
    <FormControl fullWidth disabled={disabled || isLoading}>
      <InputLabel id={labelId}>{selectName}</InputLabel>
      <Select
        placeholder={placeholder}
        labelId={labelId}
        value={value || ''} // Use empty string if value is null
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled || isLoading}
        error={error}
        input={
          <OutlinedInput
            endAdornment={
              isLoading ? (
                <InputAdornment
                  position="end"
                  sx={{
                    marginRight: '16px',
                  }}
                >
                  <CircularProgress size={16} />
                </InputAdornment>
              ) : null
            }
          />
        }
      >
        {items.length === 0 && !isLoading ? (
          <MenuItem disabled value="">
            No data available
          </MenuItem>
        ) : (
          items?.map((item) => (
            <MenuItem key={item.value} value={item.value}>
              {item.name}
            </MenuItem>
          ))
        )}
      </Select>
      {error && <ErrorMessage message={errorMessage} />}
    </FormControl>
  );
}
